import React from 'react';

import { useGeolocationContext } from '../hooks/geolocationContext';
import { VehicleDeviceInfo } from './VehicleDeviceInfo';

import Button from '../../../../Common/DesignSystem/Button';

export const UnrelatedDeviceCardItem = ({ vehicle }) => {
	const { openMapVehiclePin, selectedVehicle, addVehicle } = useGeolocationContext();

	if (!vehicle) return <></>;

	const { vin, gpsDevice } = vehicle;

	return (
		<div
			data-testid="unrelated-device-card-item"
			className={`vehicle-card-item ${selectedVehicle?.id === vehicle.id ? 'vehicle-active' : ''}`}
			onClick={() => openMapVehiclePin(vehicle)}
		>
			<div className='vehicle-main-info'>
				<div className='vehicle-image'>
					<img src='images/vehicle/unrelated-gps-device.svg' alt="Vehicle image" />
				</div>
				<div className='vehicle-device-info'>
					<VehicleDeviceInfo device={gpsDevice} vin={vin} />
				</div>
			</div>
			<div className='vehicle-fleet-info'>
				<Button label="Add to Fleet" small secondary onClick={addVehicle}/>
			</div>
		</div>
	);
}
